export default "<div class=\"pagweNotFound\"> </div>\r\n"